// extracted by mini-css-extract-plugin
export default {"container":"BottomNavi_container__1gwqC"};